import { memo, FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AgentEvent, Colors } from 'Types';
import { Button, Card, FontAwesome } from 'Elements';
import { clx, config, formatLocaleDateTime } from 'Utils';

interface Props {
	className?: string;
	event: AgentEvent;
}

export const EventPublishBar: FC<Props> = memo(({ event, className }) => {
	const { t } = useTranslation();
	const previewUrl = `${config.publicUrl}/event/${event?.id}/${event.slugTitle}`;

	const redirectToPreview = () => {
		window.open(previewUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<Card
			background="green_o-2"
			className={clx(
				className,
				'd-flex align-items-md-center flex-column flex-md-row mb-4'
			)}>
			<div className="d-flex align-items-md-center flex-column flex-md-row flex-wrap flex-grow-1 mb-3 mb-md-0 pe-3 gap-3">
				<div className="d-flex align-items-center me-2">
					<FontAwesome
						icon="code-branch"
						size="lg"
						className="me-2 flex-shrink-0"
					/>
					<span className="text-gray-3 fw-400">
						{t('card.published-version')}:
					</span>
					<span className="ms-1 text-gray-5">
						{event.publishedVersion ?? '...'}
					</span>
				</div>
				<div className="d-flex align-items-center me-2">
					<FontAwesome
						icon="calendar-days"
						size="lg"
						className=" me-2 flex-shrink-0"
					/>
					<span className="text-gray-3">
						{t('card.published-date')}:
					</span>
					<span className="ms-1 text-gray-5">
						{event?.publishedAt
							? formatLocaleDateTime(event?.publishedAt)
							: '...'}
					</span>
				</div>
			</div>
			<div className="ms-md-auto d-flex align-items-center gap-2">
				<Button
					color={Colors['white-primary']}
					className="gap-2"
					onClick={redirectToPreview}>
					<FontAwesome icon="eye" size="lg" />
					{t('button.view')}
				</Button>
			</div>
		</Card>
	);
});

EventPublishBar.displayName = 'EventPublishBar';
